module.exports = "\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/kiosk-setup-wizard/kiosk-setup-wizard.component.css
// module id = ./src/app/kiosk-setup-wizard/kiosk-setup-wizard.component.css
// module chunks = main